import { Expose } from "@nts/std/serialization";
import { PropertyMetaData } from './property-meta-data';
import { BigNumber } from "@nts/std/types";
import type { NumericMetaDataInterface } from '@nts/std/interfaces';
import { UserMetaData } from "./user-meta-data";
import { MetaDataDescriptions } from "./meta-data-descriptions";

export class NumericMetaData<TModelType = BigNumber | number> extends PropertyMetaData implements NumericMetaDataInterface<TModelType> {

    static TYPE = 'Numeric';
    protected override _type = NumericMetaData.TYPE;

    constructor(
        name?: string,
        descriptions?: MetaDataDescriptions,
        userMetaData?: UserMetaData,
        isRequired?: boolean,
        position?: number,
        minValue?: TModelType,
        maxValue?: TModelType,
        minDecimalValue?: TModelType,
        maxDecimalValue?: TModelType,
    ) {
        super(
            name,
            descriptions,
            userMetaData,
            isRequired,
            position,
        );
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.minDecimalValue = minDecimalValue;
        this.maxDecimalValue = maxDecimalValue;
    }

    /**
     * Eventuale valore minimo ammesso
     */
    @Expose()
    minValue?: TModelType;

    /**
     * Eventuale valore massimo ammesso
     */
    @Expose()
    maxValue?: TModelType;

    /**
     * Eventuale valore minimo
     */
    @Expose()
    minDecimalValue?: TModelType;

    /**
     * Eventuale valore massimo
     */
    @Expose()
    maxDecimalValue?: TModelType;

    /**
     * Numero massimo cifre per la parte decimale
     */
    @Expose()
    maxDecimalPrecision?: number;

    /**
     * Numero massimo cifre per la parte intera
     */
    @Expose()
    maxIntegerPrecision?: number;

    /**
     * Viene calcolata automaticamete? utile per mettere in readonly le identity
     */
    @Expose()
    isAutoComputed?: boolean;

    /**
     * Il metadata rappresenta un numero decimale
     */
    @Expose()
    isDecimal: boolean;

    override set(data: {
        minValue?: TModelType;
        maxValue?: TModelType;
        minDecimalValue?: TModelType;
        maxDecimalValue?: TModelType;
        maxDecimalPrecision?: number;
        maxIntegerPrecision?: number;
        isAutoComputed?: boolean;
        isDecimal?: boolean;
    }) {
        super.set(data);
        if (data?.minValue != null) {
            this.minValue = data.minValue;
        }
        if (data?.maxValue != null) {
            this.maxValue = data.maxValue;
        }
        if (data?.minDecimalValue != null) {
            this.minDecimalValue = data.minDecimalValue;
        }
        if (data?.maxDecimalValue != null) {
            this.maxDecimalValue = data.maxDecimalValue;
        }
        if (data?.maxDecimalPrecision != null) {
            this.maxDecimalPrecision = data.maxDecimalPrecision;
        }
        if (data?.maxIntegerPrecision != null) {
            this.maxIntegerPrecision = data.maxIntegerPrecision;
        }
        if (data?.isAutoComputed != null) {
            this.isAutoComputed = data.isAutoComputed;
        }
    }


}
